// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__92EFx","buttons":"PendingPaymentAlert_buttons__1u_yl"};